export default {
	install(Vue) {
		Vue.prototype.$checkPermission = function (permission) {
			return (this.$myStore.state.user.permissions.indexOf(permission) !== -1);
		};

		Vue.prototype.$codePattern = /[^A-Za-zčćžšđČĆŽŠĐ0-9]+/

		Vue.prototype.$timePattern = /(?:[01]\d|2[0-3]):(?:[0-5]\d):(?:[0-5]\d)/

		Vue.prototype.$dateTimePattern = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])) (?:[01]\d|2[0-3]):(?:[0-5]\d):(?:[0-5]\d)/

		Vue.prototype.$checkEmail = function (email) {
			var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		};

		Vue.prototype.$checkOIB = function (oib) {
			oib = oib.toString();
			if (oib.length != 11) return false;

			var b = parseInt(oib, 10);
			if (isNaN(b)) return false;

			var a = 10;
			for (var i = 0; i < 10; i++) {
				a = a + parseInt(oib.substr(i, 1), 10);
				a = a % 10;
				if (a == 0) a = 10;
				a *= 2;
				a = a % 11;
			}
			var control = 11 - a;
			if (control == 10) control = 0;

			return control == parseInt(oib.substr(10, 1));
		};

		Vue.prototype.$sortByKey = function (array, key) {
			return array.sort(function (a, b) {
				var x = a[key].toLowerCase();
				var y = b[key].toLowerCase();
				return ((x < y) ? -1 : ((x > y) ? 1 : 0));
			});
		}

		Vue.prototype.$getCookie = function (cname) {
			var name = cname + "=";
			var decodedCookie = decodeURIComponent(document.cookie);
			var ca = decodedCookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return "";
		}

		Vue.prototype.$setCookie = function (cname, cvalue, exdays) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			var expires = "expires=" + d.toUTCString();
			document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		}

		Vue.prototype.$formatMoney = function (amount, decimalCount = 2, decimal = ",", thousands = ".") {
			decimalCount = Math.abs(decimalCount);
			decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

			const negativeSign = amount < 0 ? "-" : "";

			let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
			let j = (i.length > 3) ? i.length % 3 : 0;

			return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
		};

		Vue.prototype.$formatDateFromDashes = function (date) {
			let dateArray = date.split('-');
			return dateArray[2] + '.' + dateArray[1] + '.' + dateArray[0] + '.';
		}
		Vue.prototype.$formatDateToDashes = function (date) {
			let dateArray = date.split('.');
			return dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
		}

		Vue.prototype.$setSubMenu = function (menuId) {
			let submenus = ['Lists', 'Finance', 'Reporting', 'Settings'];
			for (let menu of submenus) {
				if (menu != menuId) {
					this.$myStore.commit('setSubMenu' + menu, false);
				}
			}
			if (menuId != '') {
				this.$nextTick(() => {
					this.$myStore.commit('setSubMenu' + menuId, true);
				});
			}
		}

		Vue.prototype.$tinymceInit = {
			menubar: false,
			statusbar: true,
			height: 500,
			resize: true,
			paste_as_text: true,
			object_resizing: true,
			relative_urls: false,
			remove_script_host: false,
			branding: false,
			plugins: 'table, lists, code, paste, link, autolink',
			toolbar: "bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist | table | code | link"
		};

		Vue.prototype.$tinymceInitSmall = {
			menubar: false,
			statusbar: true,
			height: 130,
			resize: true,
			paste_as_text: true,
			object_resizing: true,
			relative_urls: false,
			remove_script_host: false,
			branding: false,
			plugins: 'table, lists, code, paste, link, autolink',
			toolbar: "bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist | table | code | link"
		};

		Vue.prototype.$tinymceInitSmall5 = {
			menubar: false,
			statusbar: true,
			height: 250,
			resize: true,
			paste_as_text: true,
			object_resizing: true,
			relative_urls: false,
			remove_script_host: false,
			branding: false,
			plugins: 'table, lists, code, paste, link, autolink',
			toolbar: "bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist | table | code | link"
		};

		Vue.prototype.$tinymceInitSmall10 = {
			menubar: false,
			statusbar: true,
			height: 400,
			resize: true,
			paste_as_text: true,
			object_resizing: true,
			relative_urls: false,
			remove_script_host: false,
			branding: false,
			plugins: 'table, lists, code, paste, link, autolink',
			toolbar: "bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist | table | code | link"
		};

		Vue.prototype.$tinymceInitSmall15 = {
			menubar: false,
			statusbar: true,
			height: 600,
			resize: true,
			paste_as_text: true,
			object_resizing: true,
			relative_urls: false,
			remove_script_host: false,
			branding: false,
			plugins: 'table, lists, code, paste, link, autolink',
			toolbar: "bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist | table | code | link"
		};

		Vue.prototype.$tinymceInitReadOnly = {
			menubar: false,
			statusbar: true,
			height: 130,
			resize: true,
			object_resizing: true,
			relative_urls: false,
			remove_script_host: false,
			branding: false,
			plugins: '',
			toolbar: false
		};

		Vue.prototype.$tinymceInitReadOnly10 = {
			menubar: false,
			statusbar: true,
			height: 400,
			resize: true,
			object_resizing: true,
			relative_urls: false,
			remove_script_host: false,
			branding: false,
			plugins: '',
			toolbar: false
		};
	}
}
